<template>
  <div class="ag-header">
    <div class="logo-wrap">
      <img src="../../../assets/logo-1.png" class="logo">
      <span class="text">业务数据管理平台</span>
    </div>
    <div class="tab-wrap">
      <HeaderTab></HeaderTab>
    </div>
    <div class="user-wrap">
<!--       <div class="name">-->
<!--        <i class="user-icon"></i>-->
<!--        <span class="text" @click="handlerClick('/chooseClient')">{{loginUser.client.name}}</span>-->
<!--      </div>-->
     <a-dropdown>
        <a href="#" style="color:white">
          {{ loginUser.name }}
          <a-icon type="down"/>
        </a>
        <a-menu slot="overlay" @click="handlerClick">
          <a-menu-item key="/login">
            <span>退出</span>
          </a-menu-item>
<!--          <a-menu-item key="/overview" v-if="(hasLoginUserCookies)()">-->
<!--            <span>返回产品页</span>-->
<!--          </a-menu-item>-->
        </a-menu>
      </a-dropdown>

    </div>
  </div>
</template>

<script>
import HeaderTab from '../../tab/headerTab'
import { authorityMixin } from '../../../common/mixin/mixin'
import { hasLoginUserCookies } from '../../../../../../utils/util'
import Cookies from 'js-cookie'
import storage from 'good-storage'

export default {
  name: 'adHeader',
  mixins: [authorityMixin],
  data () {
    return {}
  },
  components: {
    HeaderTab
  },
  methods: {
  hasLoginUserCookies,
    handlerClick ({ key }) {
      let position = key || arguments[0]
      let hostname = window.location.hostname
      if (hasLoginUserCookies()) { // 有cookie，意味着本轮操作从聚合平台过来的，因为从当前平台登陆过来的话，cookie会被置空
       if (process.env.VUE_APP_BASE_TRUE_ENV === 'true') {
          Cookies.set('jumpFromOtherPlatform', true, { domain: 'cue.group' })
        } else {
          Cookies.set('jumpFromOtherPlatform', true)
        }
        if (process.env.NODE_ENV === 'development') {
          window.location.href = `http://${hostname}:${process.env.VUE_APP_BASE_URL_E}/home/#${position}`
        } else {
         if (process.env.VUE_APP_BASE_TRUE_ENV === 'true') { // production
            window.location.href = `${process.env.VUE_APP_BASE_URL_E}/#${position}`
          } else { // test
            window.location.href = `http://${hostname}:${process.env.VUE_APP_BASE_URL_E}/#${position}`
          }
        }
      } else {
        this.$router.push(position)
      }
    }
  }
}
</script>

<style scoped lang='less'>
  @import '../../../common/styles/varibles.less';
  @import '../../../common/styles/mixins.less';

  .ag-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 64px;
    background-color: #474748;
    font-size: 14px;
    font-family: @pr;
    .logo-wrap,
    .tab-wrap,
    .user-wrap {
      display: flex;
      height: 100%;
    }
    .logo-wrap {
      display: flex;
      width: 250px;
      align-items: center;
      padding-left: 24px;
      .logo {
        box-sizing: border-box;
        width: 53px;
        height: 24px;
        padding-right: 16px;
        transform: translate(0, -2px);
      }
      .text {
        color: @w;
        padding-left: 16px;
        border-left: 1px solid rgba(255, 255, 255, 0.5);
      }
    }
    .tab-wrap {
     padding-left: 20px;
      flex: 1;
      height: 100%;
      background-color: #474748;
      display:flex;
      /*justify-content:center;*/
      align-items:center;
    }
    .user-wrap {
      display: flex;
      align-items: center;
      padding-right: 25px;
      float: right;
      color: @w;
      .count {
        cursor: pointer;
      }
       .user-menu {
        width: 120px;
        color: #fff;
        .ant-menu-submenu {
          width: 100%;
        }
        .ant-menu-submenu-title {
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .name {
        cursor: pointer;
        margin-right: 32px;
        display: flex;
        .user-icon {
          .backgroundImg('../../assets/user.png');
          width: 24px;
          height: 24px;
        }
        .text {
          margin-left: 8px;
          margin-right: 9px;
          line-height: 24px;
          height: 24px;
        }
        .anticon-down {
          transform: translate(0, 5px);
        }
      }
    }
  }
</style>
